import * as yup from 'yup'
import { REQUIRED_MESSAGE } from '../../constants'

export const RecipientSchema = yup.object({
  user: yup
    .object({
      id: yup.string().required(REQUIRED_MESSAGE),
      text: yup.string(),
      name: yup.string(),
      email: yup.string(),
    })
    .required(REQUIRED_MESSAGE),
  receiveNotifications: yup.boolean(),
})

export type TRecipientSchema = yup.InferType<typeof RecipientSchema>
